<div class="col-12 nex-steps-3" [ngClass]="{'nex-steps-4': hasSignature, 'nex-steps-3': !hasSignature}">
  <p-steps [model]="process" [(activeIndex)]="activeIndex"></p-steps>
</div>

<div class="col-12">
  <div class="col-4 align-left">
  </div>
  <div class="col-4 align-center">
  </div>
  <div class="col-4 align-right">
    <button *ngIf="currentStep === ExpressDepositComponent.REVIEW_STEP" type="button" [icon]="'fa fa-check'"
            class="p-button-warning" [iconPos]="'right'"
            [label]="'COMMON.VALIDATE' | translate" pButton (click)="saveExpressDeposit()"></button>
  </div>
</div>
<div class="col-12" *ngIf="currentStep === ExpressDepositComponent.INFO_ERL">
  <app-deposit-erl-info (moveNext)="nextStep()" (infoERL)="infoERL($event)" (typeErl)="setTypeErl($event)" (addressSender)="setAddressSender($event)"></app-deposit-erl-info>
</div>

<div class="col-12" *ngIf="currentStep === ExpressDepositComponent.PARAMS_STEP">
  <app-deposit-options [depositType]="DepositDepotExpressEnum.ERL"  [typeErl]="this.erlType" [erl]="erlInfo" [senderAddress]="senderAddress" [showButtonDeposit]="false" [showButtonMailing]="false"
                       (moveNext)="nextStep()" (signatureChange)="setSignatureFile($event)" (hasBounce)="setHasBounce($event)"
                       (depositDirChange)="setDepositDir($event)"></app-deposit-options>
</div>

<div class="col-12" *ngIf="currentStep === ExpressDepositComponent.DATA_STEP">
  <div class="col-12 align-right">
    <button [disabled]="!nextEnabled()" type="button" [icon]="'fa fa-hand-o-right'"
            [label]="'COMMON.NEXT' | translate" pButton (click)="nextStep()"></button>
  </div>
  <div class="col-3">
    <div class="col-12">
      <p-fieldset [legend]="'UPLOAD_COMPONENT.DATA_FILE_SELECTION' | translate">
        <div class="col-12">
          <div class="col-6">
            <button pButton type="button" [label]="'UPLOAD_COMPONENT.DATA_FILE_MODEL_DOWNLOAD' | translate"
                    class="p-button-success" tooltipPosition="right"
                    [pTooltip]="'UPLOAD_COMPONENT.DATA_FILE_MODEL_DOWNLOAD_TOOLTIP' | translate"
                    (click)="downloadModel()"></button>
          </div>
          <div class="col-6" (click)="showColumnHelp()">
            <i class="fa fa-question-circle cols-tool-tip-button"></i>
          </div>
        </div>

        <div class="col-12">
          <app-files-upload filesTitle=""
                            [moreThanOneFile]="false"
                            [acceptedFiles]="getListOfAcceptedFiles(FileStatus.DATA)"
                            [optional]="false"
                            [shouldClearFiles]="shouldClearFiles"
                            (isValid)="updateUploadValidity(FileStatus.DATA,$event)"
                            (selectedFiles)="setDataFile(FileStatus.ANNEX,$event)"></app-files-upload>
        </div>
      </p-fieldset>
    </div>
  </div>
  <div class="col-9">
    <p-fieldset [legend]="'UPLOAD_COMPONENT.DATA_FILE_PREVIEW' | translate">

      <div class="col-12">
        <div class="col-4">
          <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_COUNT' | translate}}:</div>
          <div class="col-2"> {{recipientData?.length ?? 0}}</div>
        </div>
        <div class="col-4">
          <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_VALID' | translate}}:</div>
          <div class="col-2"> {{erlDataValidRows}}</div>
        </div>
        <div class="col-4">
          <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_INVALID' | translate}}:</div>
          <div class="col-2"> {{erlDataInValidRows}}</div>
        </div>
      </div>

      <div class="col-4">
        <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_COUNT_MAIL' | translate}}:</div>
        <div class="col-2"> {{recipientData?.length ?? 0}}</div>
      </div>
      <div class="col-4">
        <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_VALID_MAIL' | translate}}:</div>
        <div class="col-2"> {{erlDataValidMailRows}}</div>
      </div>
      <div class="col-4">
        <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_INVALID_MAIL' | translate}}:</div>
        <div class="col-2"> {{erlDataInValidMailRows}}</div>
      </div>

      <div class="col-4">
        <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_COUNT_NAME_RECIPIENT' | translate}}:</div>
        <div class="col-2"> {{recipientData?.length ?? 0}}</div>
      </div>
      <div class="col-4">
        <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_VALID_NAME_RECIPIENT' | translate}}:</div>
        <div class="col-2"> {{erlDataValidRecipientRows}}</div>
      </div>
      <div class="col-4">
        <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_INVALID_NAME_RECIPIENT' | translate}}:</div>
        <div class="col-2"> {{erlDataInValidRecipientRows}}</div>
      </div>

      <div class="col-3" *ngIf="((recipientData?.length >0 && erlDataInValidRows > 0) )">
        <button pButton type="button" [label]="'UPLOAD_COMPONENT.DELETE_INVALID_ROWS_LABEL' | translate"
                class="p-button-success"
                (click)="removeInvalidMailingRows()"
                [pTooltip]="'UPLOAD_COMPONENT.DELETE_INVALID_ROWS_TOOLTIP' | translate"></button>
      </div>
      <div class="col-12">
        <p-table *ngIf="showMailingData" [value]="recipientData"
                 selectionMode="single" [scrollable]="true" scrollHeight="540px" dataKey="id">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 4em">{{ 'UPLOAD_COMPONENT.ERL_FIELDS.LINE_NB' | translate }}</th>
              <th [pSortableColumn]="'valid'" style="width: 6em">{{ 'UPLOAD_COMPONENT.ERL_FIELDS.VALIDITY' | translate }}</th>
              <th>{{ 'UPLOAD_COMPONENT.ERL_FIELDS.RECIPIENT' | translate }}</th>
              <th>{{ 'UPLOAD_COMPONENT.ERL_FIELDS.EMAIL_ADDRESS' | translate }}</th>
              <th>{{ 'UPLOAD_COMPONENT.ERL_FIELDS.PHONE' | translate }}</th>
              <th>{{ 'UPLOAD_COMPONENT.ERL_FIELDS.POSTAL_ADDRESS' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr>
              <td style="width: 4em">{{rowIndex + 1}}</td>
              <td style="width: 6em">
                <button *ngIf="isValidRow(rowData)" class="p-button-success" type="button" [icon]="'fa fa-check'"
                        [pTooltip]="'COMMON.INFORMATION_RECIPIENT_IS_VALID' | translate" pButton></button>
                <div *ngIf="!isValidRow(rowData)" class="flex gap-1">
                  <button class="p-button-warning" type="button" [icon]="'fa fa-pencil'"
                          [pTooltip]="'COMMON.CORRECT_INFORMATION' | translate" pButton (click)="editRowRecipient(rowData, rowIndex)"></button>
                  <button class="p-button-danger" type="button" [icon]="'fa fa-close'"
                          [pTooltip]="'COMMON.DELETE' | translate" pButton (click)="removeRecipient(rowData)"></button>
                </div>
              </td>
              <td [ngClass]="rowData.isValidIdentityRecipient() ? null : 'invalid-address'"> {{getRecipient(rowData)}} </td>
              <td [ngClass]="rowData.isValidMail() ? null : 'invalid-address'">{{ rowData.recipient.mailAddress }}</td>
              <td>{{ rowData.recipient.phoneNumber }}</td>
              <td [ngClass]="rowData.isValid() ? null : 'invalid-address'">{{ rowData.recipient.address.join(', ') }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-fieldset>
  </div>
</div>

<div class="col-12" *ngIf="currentStep === ExpressDepositComponent.TEMPLATE_STEP">
  <div class="col-12 align-right" *ngIf="this.erlType === ErlTypeEnum.ERL_UNIT">
    <button type="button" [icon]="'fa fa-hand-o-right'" [disabled]="!nextEnabled()"
            [label]="'COMMON.NEXT' | translate" pButton (click)="nextStep()"></button>
  </div>
  <div class="col-3">
    <div class="col-12" *ngIf="templateSource === 'USER_PDF'">
      <app-files-upload
        [filesTitle]="'UPLOAD_COMPONENT.MAIN_FILE_SELECTION' | translate"
        [moreThanOneFile]="false"
        [acceptedFiles]="acceptedUtinFiles"
        [optional]="false"
        [shouldClearFiles]="shouldClearFiles"
        (isValid)="updateUploadValidity(FileStatus.MAIN,$event)"
        (selectedFiles)="setMainFile(FileStatus.MAIN,$event)">
      </app-files-upload>
    </div>

    <p-fieldset [legend]="'UPLOAD_COMPONENT.ADDRESS_CAPTURE_RESULT' | translate"
                *ngIf="pagesImages && pagesImages.hasOwnProperty('page_1') && erlType === ErlTypeEnum.ERL_UNIT">

      <div class="col-12 flex align-items-center gap-2">
        <span>Saisie manuelle</span>
        <p-inputSwitch [(ngModel)]="writeManually"  (onChange)="switchWrittingWay($event)"></p-inputSwitch>
      </div>

      <div class="col-12" *ngIf="writeManually">
        <div class="grid">
          <div class="col-12">
            <div class="col-9">
              <textarea id="senderAddress" rows="5" [readOnly]="true" class="w-full"
                        [ngClass]="{'not-valid': !isValidAddress(addressRecipient), 'valid': isValidAddress(addressRecipient) }"
                        [(ngModel)]="addressRecipient" pInputTextarea [autoResize]="false"></textarea>
            </div>
            <div class="col-2">
              <button pButton type="button" [icon]="'fa fa-pencil'" class="p-button-info"
                      [label]="'COMMON.EDIT' | translate"
                      (click)="showRecipientAddress()"></button>
              <p-dialog *ngIf="openRecipientAddress" [(visible)]="openRecipientAddress" [styleClass]="'adressModal'"
                        [appendTo]="'body'"
                        [header]="'FOLD.ACTION_COMPONENT.ADD_MODAL_TITLE' | translate"
                        [draggable]="false"
                        [closable]="true"
                        [resizable]="false"
                        [modal]="true" [closeOnEscape]="false">
                <app-address (finalAddress)="handleRecipientAddress($event)"
                             (visible)="handleRecipientAddressClose($event)"
                             [oldAddress]="currentRecipientAddress"></app-address>
              </p-dialog>
            </div>
          </div>
        </div>
      </div>


      <div class="col-12 extract-region-result" *ngIf="!writeManually">
        <div class="col-12"
             *ngIf="(!extractedAddress || !extractedAddress.isValid()) && resultItems && resultItems.length >0">
          <div class="col-12" *ngFor="let item of resultItems">
            {{item}}
          </div>
        </div>
        <div class="col-12"
             *ngIf="extractedAddress && extractedAddress.isValid() && extractedAddress && extractedAddress.formatted && extractedAddress.formatted.length >0">
          <div class="col-12" *ngFor="let item of extractedAddress.formatted">
            <ng-container *ngIf="item.toUpperCase() !== 'FRANCE'">{{item}}</ng-container>
          </div>
        </div>

        <div class="col-12">
          <div class="col-6" *ngIf="extractedAddress && extractedAddress.isValid()"
               style="font-size: 1.3em; color: #107D11">{{'COMMON.ADDRESS_IS_VALID'|translate}}</div>
          <div class="col-6" *ngIf="!extractedAddress || !extractedAddress.isValid()"
               style="font-size: 1.3em; color: #e71808">{{'COMMON.ADDRESS_IS_NOT_VALID'|translate}}
          </div>
          <div class="col-12">
            <button *ngIf="!extractedAddress || !extractedAddress.isValid()" pButton type="button"
                    [label]="'COMMON.CORRECT_ADDRESS' | translate" class="p-button-success"
                    (click)="editUnitAddress()"></button>
            <button *ngIf="extractedAddress && extractedAddress.isValid()" pButton type="button"
                    [label]="'COMMON.MODIFY_ADDRESS' | translate" class="p-button-success"
                    (click)="editUnitAddress()"></button>
          </div>
        </div>
      </div>

    </p-fieldset>
  </div>
  <div class="col-9">
    <div class="col-12" *ngIf="mainFile && this.erlType === ErlTypeEnum.ERL_UNIT">
      <p-fieldset [legend]="'UPLOAD_COMPONENT.ADDRESS_DOC_CAPTURE' | translate"
                  *ngIf="pagesImages && pagesImages.hasOwnProperty('page_1')">

        <div class="col-12" *ngIf="pageCount > 1">
          <p-paginator [rows]="1" [totalRecords]="pageCount" (onPageChange)="updateBG($event)"
                       [showCurrentPageReport]="true"
                       [currentPageReportTemplate]="'Page:  {currentPage} sur {totalPages}'"></p-paginator>
        </div>

        <div class="col-12">
          <div  class="extract-region-container" #addressDragContainer>
            <div class="extract-region-bg" [ngStyle]="containerBGStyle">
              <!--<div class="omr left-omr"></div>
              <div class="omr right-omr"></div>-->
              <div class="extract-region-rect" *ngIf="!writeManually" #addressTargetContainer [ngStyle]="targetContainerStyle"
                   ngResizable="true"
                   ngDraggable="true"
                   [rzHandles]="'n,e,s,w,se,sw,ne,nw'"
                   (endOffset)="recalculateRegion()"
                   (rzStop)="recalculateRegion()"
                   [bounds]="addressDragContainer"
                   rzContainment="#addressDragContainer"
                   [inBounds]="true"
              ></div>
            </div>
          </div>
        </div>
      </p-fieldset>
    </div>
  </div>
</div>

<div class="col-12" *ngIf="currentStep === ExpressDepositComponent.FORMATTING_STEP">
  <app-signature-options [signature]="signature" [depositDir]="depositDir" [pagesImages]="pagesImages"
                         [pageCount]="pageCount" [pages]="pages"
                         [sigPages]="sigPages"
                         (stored)="signaturePositionStored($event)"></app-signature-options>
</div>

<div class="col-12" *ngIf="currentStep === ExpressDepositComponent.REVIEW_STEP">
  <app-deposit-review [type]="DepositDepotExpressEnum.ERL" [depositDir]="depositDir" [customizedFilePdf]="customizedFilePdf"
                      [foldCount]="foldCount"></app-deposit-review>
</div>

<div *ngIf="showEditRow">
  <p-dialog [styleClass]="'express-address-dialog'" [appendTo]="'body'" [(visible)]="showEditRow"
            [header]="modalTitleEdit"
            [draggable]="true"
            [focusTrap]="false"
            [modal]="true">
    <app-deposit-erl-recipient (finalRecipient)="updateRecipient($event)"
                               [selectedRow]="this.editRecipient"
                               [index]="editRecipientIndex"></app-deposit-erl-recipient>
    <!-- <a href="pdfToDisplay">Download PDF</a>-->
  </p-dialog>
</div>

<div class="saving-loader-modal">
  <p-dialog [appendTo]="'body'" [(visible)]="displayLoading" [header]="'UPLOAD_COMPONENT.LOADER_TITLE' | translate"
            id="ex-save-loader" [draggable]="false" [closable]="false" [resizable]="false"
            [modal]="true" [closeOnEscape]="false">
    <div class="center">
      <div class="col-12" *ngIf="savingTrial && savingTrial > 1">
        <p>{{'UPLOAD_COMPONENT.SAVE_DEPOSIT_TRIAL' | translate}}: {{savingTrial}}</p>
      </div>
      <p *ngIf="depositPersistedSerialLot">{{'UPLOAD_COMPONENT.STATUS_SERIAL_DEPOSIT' | translate}}
        : {{depositPersistedSerialLot}}</p>
      <p-progressBar [value]="progressPersisted"></p-progressBar>
      <div class="col-12" *ngIf="depositPersistedSerialLot">
        <button pButton type="button" (click)="closeLoader()" [label]="'COMMON.CLOSE' | translate"
                class="p-button-danger"></button>
      </div>
      <p></p>
      <p>{{'UPLOAD_COMPONENT.LOADER_HINT' | translate}}</p>
    </div>
  </p-dialog>
</div>

<div *ngIf="openVisualization">
  <p-dialog [styleClass]="'file-display-dialog'" [appendTo]="'body'" [(visible)]="openVisualization"
            [header]="'Je vérifie mon courrier avant de le soumettre '" (onHide)="freeDocMemory(pdfToDisplay)"
            [draggable]="true"
            [closable]="true"
            [maximizable]="true"
            [modal]="true" [closeOnEscape]="true">
    <object *ngIf="pdfToDisplay && !msBrowsers" [data]="pdfToDisplay + '#view=FitH&zoom=100' | safeObjUrl"
            type="application/pdf" width="100%"
            height="100%"></object>
    <!-- <a href="pdfToDisplay">Download PDF</a>-->
  </p-dialog>
</div>

<div *ngIf="displayColumnHelp" class="col-help-modal">
  <p-dialog header="Format de fichier de données" [(visible)]="displayColumnHelp"
            [minY]="70"
            [maximizable]="true" [baseZIndex]="11000"
            [closable]="true"
            [closeOnEscape]="true">
    <div class="col-12">
      <h4>Le contenu</h4>
      <p>Votre fichier de données doit au moins contenir les informations du destinataire (voir plus bas ).
      </p>
      <p>Vous pouvez ajouter autant de colonnes que vous le souhaiter. Les données qu'elles contiennent peuvent
        être:</p>
      <ul>
        <li>associées au document sous forme de métadonnées (le choix est proposé aprés la sélection du fichier de donnée);</li>
        <li>insérées dans le courrier si vous choisissez le mode création dans l'étape suivante.</li>
      </ul>

      <h4>Le Format</h4>
      <p>Pour une meilleure prise en charge de votre fichier veuillez respecter les règles suivantes </p>
      <ul>
        <li>Le Fichier doit être encodé en UTF-8 (SANS le BOM);</li>
        <li>La valeur d'une cellule ne doit pas dépaser 38 caractères;</li>
        <li>Le nommage de colonnes est sensible à la casse;</li>
        <li>L'ordre des colonnes dans le fichier n'a pas d'importance.</li>
      </ul>
    </div>
    <h4 class="title-helper">Les informations du destinataire</h4>
    <div class="col-12 note-1">
      <div class="col-12 subtitle-helper">Sur l'identité du destinataire<span>*</span></div>
      <div class="col-12">
        <div class="col-12 subtitle-identity-helper">Si le destinataire est une personne physique<span>**</span></div>
        <div class="col-12 content-identity-helper">
          <div class="col-12">
            <div class="col-3">Titre<span>*</span></div>
            <div class="col-9">Veuillez renseigner soit "Monsieur", soit "Madame"</div>
          </div>
          <div class="col-12">
            <div class="col-3">Prénom<span>*</span></div>
            <div class="col-9">Prénom du destinataire</div>
          </div>
          <div class="col-12">
            <div class="col-3">Nom<span>*</span></div>
            <div class="col-9">Nom du destinataire</div>
          </div>
        </div>
        <div class="col-12 subtitle-identity-helper">Si le destinataire est une personne physique<span>**</span></div>
        <div class="col-12 content-identity-helper">
          <div class="col-12">
            <div class="col-3">Entreprise<span>*</span></div>
            <div class="col-9">Nom de l'entreprise destinataire</div>
          </div>
        </div>
      </div>
      <div class="col-12 subtitle-helper">Autres informations<span>*</span></div>
      <div class="col-12">
        <div class="col-12">
          <div class="col-3">Adresses Mail<span>*</span></div>
          <div class="col-9">Adresse mail du destinataire</div>
        </div>
        <div class="col-12">
          <div class="col-3">Telephone</div>
          <div class="col-9">Si vous souhaitez être prévus par SMS. Dans le cas contraire, veuillez laisser ce champ vide.</div>
        </div>
      </div>
    </div>
    <h4 class="title-helper">Les informations de l'adresse</h4>
    <div class="col-12 note-1">
      <div class="col-12">
        <div class="col-3">Destinataire<span>*</span></div>
        <div class="col-9">Qualité, Nom, Prénom, Titre...</div>
      </div>
      <div class="col-12">
        <div class="col-3">Adresse 1<span class="super">**</span></div>
        <div class="col-9">N° Boîte aux lettre, escalier, porte...</div>
      </div>
      <div class="col-12">
        <div class="col-3">Adresse 2<span class="super">**</span></div>
        <div class="col-9">Entrée, Tours, Bâtiment, Résidence...</div>
      </div>
      <div class="col-12">
        <div class="col-3">Adresse 3<span class="super">**</span></div>
        <div class="col-9">N° de la voie, type et nom de la voie</div>
      </div>
      <div class="col-12">
        <div class="col-3">Adresse 4<span class="super">**</span></div>
        <div class="col-9">Lieu dit, Service de distribution BP</div>
      </div>
      <div class="col-12">
        <div class="col-3">Code Postal<span class="super">*</span></div>
        <div class="col-9">Sur cinq chiffres (nous consulter pur l'étranger</div>
      </div>
      <div class="col-12">
        <div class="col-3">Ville<span class="super">*</span></div>
        <div class="col-9">Nom de la localité de distribution</div>
      </div>
      <div class="col-12">
        <div class="col-3">Pays</div>
        <div class="col-9">Par défaut: France</div>
      </div>
      <div class="col-12 note-2"><span class="super">*</span> Colonnes obligatoires</div>
      <div class="col-12 note-2"><span class="super">**</span> Au moins une colonne doit être renseignée.</div>
    </div>
    <p-footer>
      <button type="button" pButton icon="pi pi-check" (click)="displayColumnHelp=false"
              [label]="'COMMON.CLOSE' | translate"></button>
    </p-footer>
  </p-dialog>
</div>

<div *ngIf="showEditAddress">
  <p-dialog [styleClass]="'express-address-dialog'" [appendTo]="'body'" [(visible)]="showEditAddress"
            [header]="'Je saisie l\'adresse du destintaire de mon courrier '"
            [draggable]="true"
            [focusTrap]="false"
            [modal]="true">
    <app-express-address (finalAddress)="updateUnitAddress($event)"
                         (visible)="handleDestAddressClose()"
                         [objAddress]="addressToEdit"
                         [lines]="addressToEditLines"></app-express-address>
    <!-- <a href="pdfToDisplay">Download PDF</a>-->
  </p-dialog>
</div>


<div *ngIf="showMailingModelEditor">
  <p-dialog [styleClass]="'edit-unit-model-editor-dialog'" [appendTo]="'body'" [(visible)]="showMailingModelEditor"
            [header]="'Je crée un nouveau modèle de courrier '"
            [draggable]="false"
            [closable]="true"
            [maximizable]="false"
            [modal]="true" [closeOnEscape]="true" (close)="editorClosed()">
    <app-mailing-model-editor [draggableColumns]="[]" [loolLink]="externalLink"
                              (closeDialogue)="closeEditor()"></app-mailing-model-editor>
  </p-dialog>
</div>
